import React from "react";
import { ArrowRight, MessageCircleQuestion, PencilLine } from "lucide-react";

const focusPromptInput = () => {
  document.querySelector('textarea[name="conversation-prompt"]')?.focus();
};

/**
 * Clarifying question with clickable option chips (prompt-kit style).
 * followUp: { question, options: [{ label, response }] }
 * Clicking an option sends option.response as the user's next message.
 */
const FollowUpOptions = ({ followUp, onOptionSelect, disabled = false }) => {
  const options = Array.isArray(followUp?.options) ? followUp.options : [];
  if (!followUp?.question && options.length === 0) return null;

  return (
    <section
      className="mt-3 w-full overflow-hidden rounded-lg border border-gray-200 dark:border-gray-800 bg-white dark:bg-gray-900"
      aria-label="Clarifying question"
    >
      <div className="flex items-start gap-3 border-b border-gray-100 dark:border-gray-800 bg-gradient-to-br from-gray-50 via-white to-white dark:from-gray-900 dark:via-gray-900 dark:to-gray-900 px-4 py-3">
        <div className="mt-0.5 flex h-8 w-8 shrink-0 items-center justify-center rounded-lg bg-secondary text-white shadow-sm">
          <MessageCircleQuestion size={16} aria-hidden="true" />
        </div>
        <div className="min-w-0">
          <p className="text-[11px] font-semibold uppercase tracking-[0.16em] text-gray-500 dark:text-gray-400">
            Quick question
          </p>
          <h3 className="text-sm font-semibold leading-6 text-gray-800 dark:text-gray-100">
            {followUp.question}
          </h3>
        </div>
      </div>

      <div className="flex flex-wrap gap-2 p-3">
        {options.map((option, index) => (
          <button
            key={`${option.label}-${index}`}
            type="button"
            disabled={disabled}
            className="group inline-flex items-center gap-2 rounded-full border border-secondary/30 bg-secondary-light-transparent dark:bg-secondary/15 px-3.5 py-2 text-left text-sm font-medium text-gray-800 dark:text-gray-200 transition-all hover:border-secondary hover:bg-white dark:hover:bg-gray-800 hover:shadow-sm focus:outline-none focus-visible:ring-2 focus-visible:ring-secondary/25 disabled:cursor-not-allowed disabled:opacity-50"
            onClick={() => onOptionSelect?.(option.response, option)}
          >
            <span className="min-w-0 break-words">{option.label}</span>
            <ArrowRight
              size={14}
              className="shrink-0 text-gray-400 dark:text-gray-400 transition-transform group-hover:translate-x-0.5 group-hover:text-secondary dark:group-hover:text-secondary-light"
              aria-hidden="true"
            />
          </button>
        ))}

        <button
          type="button"
          className="inline-flex items-center gap-2 rounded-full px-3.5 py-2 text-sm font-medium text-gray-500 dark:text-gray-400 transition hover:bg-secondary-light-transparent dark:hover:bg-secondary/20 hover:text-gray-800 dark:hover:text-gray-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-gray-300"
          onClick={focusPromptInput}
        >
          <PencilLine size={14} aria-hidden="true" />
          Write my own answer
        </button>
      </div>
    </section>
  );
};

export default FollowUpOptions;
